import { Appearance, DraftConfiguration, ProductType } from '@/types';
import { getParams } from '@/utils/params';
import { trackError } from '@/utils/raygun';
import { getPrintTypesForPrintArea } from '@/model/printType/getPrintTypesForPrintArea';
import { getPrintArea } from '@/model/productType/getPrintArea';

export const upgradePrintAreas = (
  configurations: DraftConfiguration[],
  productType: ProductType,
  appearance: Appearance
) => {
  let deprecatedPrintAreas = 0;
  let upgradedPrintAreas = 0;
  configurations.forEach((configuration) => {
    const printAreaId = configuration.printArea.id;
    const printArea = getPrintArea(productType, printAreaId);

    // if the configuration is on a deprecated print area
    if (printArea && printArea.deprecated) {
      deprecatedPrintAreas++;

      const viewId = printArea.defaultView.id;
      const defaultPrintAreaForView = productType.printAreas.find(
        ({ defaultView: { id }, deprecated }) => !deprecated && id === viewId
      );

      // and we find a print area on the same view without deprecation
      if (defaultPrintAreaForView) {
        const printTypes = getPrintTypesForPrintArea(defaultPrintAreaForView, appearance);

        // and it supports the current print type
        if (printTypes.some((printType) => printType === configuration.printType)) {
          // then switch
          configuration.printArea = defaultPrintAreaForView;
          upgradedPrintAreas++;
        }
      }
    }
  });

  if (deprecatedPrintAreas > upgradedPrintAreas) {
    trackError('Deprecated print area retained', {
      startParameter: getParams(),
      deprecatedPrintAreas,
      upgradedPrintAreas,
    });
  }
};
